var _defs, _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40",
    width: 135,
    height: 40,
    role: "img",
    "aria-label": "Get it on Google Play",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gpBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gpYellow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gpRed",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gpGreen",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 6,
    fill: "#000",
    stroke: "#A6A6A6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 0,26 13,13",
    fill: "url(#gpBlue)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13,13 18.6,7.4",
    fill: "url(#gpGreen)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,26 13,13 18.6,18.6",
    fill: "url(#gpRed)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.6,7.4 24.2,13 18.6,18.6",
    fill: "url(#gpYellow)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 14,
    fill: "#fff",
    fontFamily: "Roboto, -apple-system, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 6.5,
    fontWeight: 500,
    letterSpacing: 0.6
  }, "GET IT ON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 30,
    fill: "#fff",
    fontFamily: "Roboto, -apple-system, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 14.5,
    fontWeight: 500,
    letterSpacing: -0.2
  }, "Google Play")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.b8a444d6acb810b41408f0ffa5f0c334.svg";
export { ForwardRef as ReactComponent };